import RootPage from './edelivery-details.page.vue'

let routes = [
  {
    path: 'edelivery-details',
    name: 'edelivery-details',
    component: RootPage
  },
]

export default routes
